import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { Table } from 'components/molecules/table';

export const Section = styled.div`
  padding: var(--layout-03) 0;

  & > * {
    margin-bottom: var(--layout-03);

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Divider = styled.div`
  border-top: 1px solid var(--border-color);
  margin: var(--layout-01) 0;
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const CheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox-group-item {
    margin-right: var(--layout-01);
  }
`;
export const TimesheetSettingTable = styled(Table)`
  .ant-table-tbody .ant-table-cell {
    padding-left: var(--spacing-05);
  }
  .actions ${Button} {
    display: none;
  }
  .ant-table-row:hover .actions ${Button} {
    display: inline-block;
  }
`;
